import React from "react";
import Logo from "./Logo";

const ReferralProgramPage = ({ onBack }) => (
  <div className="min-h-screen bg-slate-950 text-slate-100 font-sans">
    <header className="fixed w-full z-50 bg-slate-950/95 backdrop-blur-md shadow-lg border-b border-slate-800 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <Logo />
          </button>
        ) : (
          <a href="/" className="flex items-center hover:opacity-80 transition-opacity">
            <Logo />
          </a>
        )}
        <div className="flex items-center gap-2">
          <a
            href="/terms"
            className="text-sm text-slate-300 hover:text-white transition-colors border border-slate-700 rounded-lg px-3 py-1.5"
          >
            Terms
          </a>
          <a
            href="/privacy"
            className="text-sm text-sky-400 hover:text-sky-300 transition-colors border border-sky-500/40 rounded-lg px-3 py-1.5"
          >
            Privacy
          </a>
        </div>
      </div>
    </header>

    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-10 space-y-10">
      <div>
        <p className="text-sky-400 uppercase text-xs font-semibold tracking-widest mb-3">Referral Program</p>
        <h1 className="text-4xl font-bold text-white mb-4">Invite lenders. Earn credits.</h1>
        <p className="text-slate-400">
          Share CloudMortgage.io with lending teams you know. When they activate a paid plan, you receive
          rewards automatically. No spreadsheets, no chasing invoices.
        </p>
      </div>

      <section className="grid md:grid-cols-3 gap-6">
        {[
          {
            title: "Get your unique link",
            body: "Copy your referral link and share it with lenders, teams, and industry partners."
          },
          {
            title: "They join and activate",
            body: "When your referral activates a paid plan, the reward is unlocked."
          },
          {
            title: "You earn credits",
            body: "Rewards are tracked automatically and added to your account balance."
          }
        ].map((item, idx) => (
          <div key={idx} className="bg-slate-900/60 border border-slate-800 rounded-2xl p-5">
            <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
            <p className="text-sm text-slate-400">{item.body}</p>
          </div>
        ))}
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Program overview</h2>
        <ul className="list-disc list-inside text-slate-400 space-y-2">
          <li>Open to lenders, brokers, and industry partners with an active CloudMortgage.io account.</li>
          <li>Rewards are earned after the referred account activates a paid subscription.</li>
          <li>Rewards are issued as account credits and can be applied to future underwriting runs.</li>
          <li>Self-referrals and spam referrals are not eligible.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Rewards and tracking</h2>
        <p className="text-slate-400">
          We track referrals automatically. You can see referral status, conversions, and earned credits in your
          account. Credits are applied after the subscription is confirmed and within the current billing cycle.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">FAQs</h2>
        <div className="space-y-4 text-slate-400">
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-5">
            <p className="text-white font-semibold mb-2">How long does attribution last?</p>
            <p>Referrals are tracked for a rolling 30 days from the first click.</p>
          </div>
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-5">
            <p className="text-white font-semibold mb-2">When do credits appear?</p>
            <p>Credits appear after the referral activates a paid plan and passes basic fraud checks.</p>
          </div>
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-5">
            <p className="text-white font-semibold mb-2">Who can I refer?</p>
            <p>Any lender or team that is new to CloudMortgage.io and not already in your organization.</p>
          </div>
        </div>
      </section>

      <section className="bg-slate-900/60 border border-slate-800 rounded-2xl p-6 space-y-4">
        <h2 className="text-2xl font-bold text-white">Get your referral link</h2>
        <p className="text-slate-400">
          Want access to the referral dashboard? Contact us and we will enable it on your account.
        </p>
        <a
          href="mailto:support@cloudmortgage.io?subject=Referral%20Program%20Access"
          className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-500 transition-colors"
        >
          Request access
        </a>
      </section>

      <div className="pt-4">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center justify-center px-5 py-3 rounded-lg border border-slate-700 text-slate-200 hover:bg-slate-900 transition-colors"
          >
            Return to Home
          </button>
        ) : (
          <a
            href="/"
            className="inline-flex items-center justify-center px-5 py-3 rounded-lg border border-slate-700 text-slate-200 hover:bg-slate-900 transition-colors"
          >
            Return to Home
          </a>
        )}
      </div>
    </main>
  </div>
);

export default ReferralProgramPage;
